module.exports = __webpack_public_path__ + "img/dataflow-01.5b11e1a4.svg";